import { render, staticRenderFns } from "./sawmill.vue?vue&type=template&id=776c50c6&"
import script from "./sawmill.component.ts?vue&type=script&lang=ts&"
export * from "./sawmill.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports